// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3OeJD","productName":"Table_productName__AFEL8"};